<div class="contentPart">
  <div class="containerPart">
    <h1 class="titrePage">Nous pouvons certainement faire mieux !</h1>
    <h2 class="titreQuestion">
      D'après vous, sur quel(s) sujet(s) devons-nous nous améliorer ?
      <p>3 choix possibles</p>
    </h2>
    <div class="questionPart">
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="questionInsidePart">
          <div *ngFor="let question of itemsQuestion; let i = index">
            <div class="blocQuestion">
              <input
                type="checkbox"
                formArrayName="selectedQuestion"
                [value]="question.id"
                (change)="onCheckboxChange($event)"
                [disabled]="checkDisabling(question.id)"
              />
              <div>
                {{ question.questionLabel }}
              </div>
            </div>
          </div>
        </div>

        <div class="messagePart">
          <label for="">Dites-nous en plus...</label>
          <textarea formControlName="message" rows="5" cols="50"></textarea>
        </div>
        <div class="boutonPart" *ngIf="form.value.selectedQuestion.length > 0">
          <button type="submit" [disabled]="!form.valid">
            Envoyer mon message
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
